module.exports = __webpack_public_path__ + "static/img/banner-02.0c8411f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/banner-02.png
// module id = F8fW
// module chunks = 1